import { render, staticRenderFns } from "./wikiProcess.vue?vue&type=template&id=354c3d52&scoped=true&"
import script from "./wikiProcess.vue?vue&type=script&lang=js&"
export * from "./wikiProcess.vue?vue&type=script&lang=js&"
import style0 from "./wikiProcess.vue?vue&type=style&index=0&id=354c3d52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c3d52",
  null
  
)

export default component.exports